import React, { useContext } from 'react';

export const DeviceContext = React.createContext<
  'mobile' | 'desktop' | undefined
>(undefined);

export default function useDeviceContext() {
  return useContext(DeviceContext);
}
